import { useState } from "react";
import { IonButton } from "@ionic/react";
import { useMutation } from "@tanstack/react-query";
import fileDownload from "js-file-download";
import { DateTime } from "luxon";
import { RequestType } from "pages/RequestIndex/RequestIndex";
import { MdDownload } from "react-icons/md";

import { exportRequests, translate } from "~utils";

import styles from "./ExportRequests.module.css";

type ExportRequestsProps = {
  requestType: RequestType;
  onSuccess: () => void;
  onFailure: () => void;
};

const fileName = (requestType: RequestType) => {
  const since = DateTime.now().minus({ months: 12 }).toFormat("MM.dd.yyyy");
  const now = DateTime.now().toFormat("MM.dd.yyyy");
  const suffix = requestType === "past-requests" ? `${since}-${now}` : now;
  return `SwingSubsData-${suffix}.csv`;
};

export function ExportRequests(props: ExportRequestsProps) {
  const { requestType, onSuccess, onFailure } = props;
  const [isDisabled, setIsDisabled] = useState(false);

  const { mutate: invokeExportRequests } = useMutation({
    mutationFn: async () => {
      setIsDisabled(true);
      const fileBlob = await exportRequests(requestType);
      fileDownload(fileBlob, fileName(requestType));
    },
    onSuccess: () => {
      setIsDisabled(false);
      onSuccess();
    },
    onError: () => {
      setIsDisabled(false);
      onFailure();
    },
  });

  return (
    <IonButton
      aria-label={translate("EXPORT_REQUEST_LABEL")}
      disabled={isDisabled}
      onClick={() => invokeExportRequests()}
      css={{ width: "auto" }}
      className={styles.hideOnMobile}
    >
      <MdDownload size={24} />
      <span className={styles.hideOnMobile}>{translate("EXPORT_REQUEST_LABEL")}</span>
    </IonButton>
  );
}

// TODO Add back once Button Component has been moved to the Swing-components library
{
  /* <button
      aria-label={translate("EXPORT_REQUEST_LABEL")}
      className={`swing-button-outline ${styles.swingButtonOutline} ${styles.hideOnMobile} ion-float-right`}
      disabled={isDisabled}
      onClick={() => invokeExportRequests()}
    >
      <span
        className={
          isDisabled
            ? `${styles.swingButtonSecondaryIconDisabled}`
            : `${styles.swingButtonSecondaryIcon}`
        }
      >
        <MdDownload className="icon-2xl" />
      </span>
      <span className={styles.hideOnMobile}>{translate("EXPORT_REQUEST_LABEL")}</span>
    </button> */
}
